import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import translationsEn from './en/translations';
import translationsRo from './ro/translations';
import LanguageDetector from 'i18next-browser-languagedetector';

export const resources = {
    en: {
        translation: translationsEn,
    },

    ro: {
        translation: translationsRo,
    },
} as const;

i18n.use(LanguageDetector)
    .use(initReactI18next)
    .init({
        fallbackLng: 'en',
        detection: {
            order: ['querystring', 'localStorage'],
            lookupQuerystring: 'langCode',
            lookupLocalStorage: 'i18nLangCode',
        },
        resources: resources,
        interpolation: {
            escapeValue: false, // react already safes from xss
        },
    });
